export default __webpack_public_path__ + "static/media/link1.bcf8854a.svg";